import type { RouteRecordRaw } from 'vue-router';

/**
 * Family Office PRIVATE routes — read-only viewer + TSV export. Product-agnostic: spread into BOTH
 * fullPrivateRoutes AND vitrinePrivateRoutes so a SHOWCASE (vitrine) session gets them too — prod runs
 * in vitrine mode, so this is the primary surface (FAMILY_OFFICE_AND_DELEGATED_OTP.md §4.8). Only one
 * product's route set is installed per session, so these names never clash across products.
 *
 * The kabinet is gated at the entry point by familyApi.access().hasAccess (a client with no grant never
 * sees it); the routes themselves are harmless without a grant (the backend returns 403 per capability).
 * Management (members / grants / delegates) is operator-side in BO — never here.
 */
export const familyRoutes: RouteRecordRaw[] = [
  { path: '/family', name: 'family', component: () => import('@/views/family/FamilyOverviewView.vue') },
  { path: '/family/member/:customerId', name: 'family-member-tx', component: () => import('@/views/family/FamilyMemberTransactionsView.vue') },
  { path: '/family/export', name: 'family-export', component: () => import('@/views/family/FamilyExportView.vue') },
];
